import { useAtomValue } from 'jotai'
import { WidgetCardEmpty } from 'src/v2/components/widget-card/empty'

import * as orAtoms from 'src/v2/state/owner-reveal'
import { OwnerSummaryContent } from 'src/v2/components/owner-summary-content'
import styled from '@emotion/styled'

const Content = styled.div`
  padding: 0 16px;
`

const NoContent = () => (
  <WidgetCardEmpty message="It looks like we don't have data for this Owner yet. We're constantly gathering new data, so keep an eye out for updates." />
)

export const OwnerSummaryCardContent = () => {
  const entityId = useAtomValue(orAtoms.selectedEntityId)

  if (!entityId) {
    return <NoContent />
  }

  return (
    <Content>
      <OwnerSummaryContent entityId={entityId} noDataContent={<NoContent />} />
    </Content>
  )
}
